<template>
  <div class="verify-code">
    <el-input
      v-model="code"
      class="code-ipt"
      :placeholder="$props.holder || $t('form.verifyCode')"
      @change="handleChange"
    />
    <img v-show="state.url" :src="state.url" @click.stop="getCodeImg" />
  </div>
</template>

<script setup>
  import {
    reactive,
    defineProps,
    defineEmits,
    computed,
    defineExpose
  } from 'vue';
  import { getVerifyCode } from '@/apis/user';
  import { base64ToBlob, getBlobToUrl } from '@/utils/searchImg';

  const $props = defineProps({
    value: {
      type: String,
      default: ''
    },
    holder: {
      type: String,
      default: ''
    }
  });
  const $emit = defineEmits(['update:value', 'change']);
  const state = reactive({
    url: '',
    uuid: ''
  });
  const code = computed({
    get() {
      return $props.value;
    },
    set(val) {
      $emit('update:value', val);
    }
  });

  const getCodeImg = async () => {
    const { img, uuid } = await getVerifyCode();
    state.url = getBlobToUrl(base64ToBlob(img));
    state.uuid = uuid;
  };

  const handleChange = () => {
    $emit('change', code.value)
  }
  getCodeImg();

  defineExpose({
    getCodeImg,
    getId: () => state.uuid
  });
</script>

<style lang="scss" scoped>
  .verify-code {
    display: flex;
    width: 100%;
    cursor: pointer;
    .code-ipt {
      width: 260px;
      height: 44px;
    }
    ::v-deep {
      .el-input {
        .el-input__wrapper {
          height: 44px;
        }
      }
    }
    > img {
      width: 118px;
      height: 44px;
      // width: 140px;
      margin-left: 22px;
    }
  }
</style>
